import React, { useState, useEffect } from "react";
import { getTranslation } from "../../../../heplers/translationHelper";
import styles from "../daysOffTable/styles.module.css";
import { useSnackbar } from "notistack";
import { CustomIframeDialog } from "../../../../layout/topbar/customIframeDialog";
import { Box, Grid, CardContent, Button, CircularProgress } from "@material-ui/core";
import CardComponent from "../../../../components/Card";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { StyledToggleButtonGroup } from "../../../../components";
import { Get } from "../../../../actions";
import { buildBookingUrl } from "../../../../utils/bookingUrl";
const IframeTab = () => {
	const { enqueueSnackbar } = useSnackbar();
	const [primaryColor, setPrimaryColor] = useState("E7424C");
	const [secondaryColor, setSecondaryColor] = useState("ffffff");
	const [openCustomIframe, setOpenCustomIframe] = useState(true);
	const [codeToggle, setcodeToggle] = useState("code");
	const [isCopied, setIsCopied] = useState(false);
	const [customerId, setCustomerId] = useState(null);
	const [loading, setLoading] = useState(true);
	
	useEffect(() => {
		setLoading(true);
	
		const fetchCustomerId = async () => {
			await Get(
				{},
				"System/GetCustomerId",
				null,
				(response) => {
					setCustomerId(response.data);
					setLoading(false);
				},
				
				(error) => {
					enqueueSnackbar(getTranslation("Failed to fetch Customer ID"), { variant: "error" });
					setLoading(false);
				}
			);
		};
		fetchCustomerId();
	}, []);
	const generatedCode = customerId ? buildBookingUrl(customerId, primaryColor, secondaryColor) : "";


	const handleCopyToClipboard = () => {
		const textField = document.createElement("textarea");
		textField.innerText = generatedCode;
		document.body.appendChild(textField);
		textField.select();
		document.execCommand("copy");
		document.body.removeChild(textField);
		setIsCopied(true);
		enqueueSnackbar(
			getTranslation(
				"Code copied to clipboard",
				"Code copied to clipboard",
				"Code copied to clipboard"
			),
			{
				variant: "success",
			}
		);
	};

	useEffect(() => {
		if (isCopied) {
			const timeoutId = setTimeout(() => {
				setIsCopied(false);
			}, 2000);

			return () => clearTimeout(timeoutId);
		}
	}, [isCopied]);

	const renderContent = () => {
		switch (codeToggle) {
			case "code":
				return (
					<Grid item sm={12} md={12} lg={12}>
						<CustomIframeDialog
							open={openCustomIframe}
							customerId={customerId}
							onClose={() => setOpenCustomIframe(false)}
							onColorChange={(primary, secondary)=>{
								setPrimaryColor(primary)
								setSecondaryColor(secondary)
							}}
						/>
					</Grid>
				);
			case "url":
				return (
					<Grid item sm={12} md={12} lg={12}>
						<label>
							{getTranslation(
								"Generated Code",
								"Generated Code",
								"Generated Code"
							) + ":"}
						</label>
						<Box border={"1px solid gray"} p={1} minHeight="100px">
							{generatedCode ? (
								<pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
									<a href={generatedCode} target="_blank" rel="noopener noreferrer">{generatedCode}</a>
								</pre>
							) : loading ? (
								<CircularProgress size={24} />
							) : null}
						</Box>
						<Button
							onClick={handleCopyToClipboard}
							color="primary"
							variant="contained"
							style={{ marginTop: "10px" }}
							disabled={!generatedCode}
						>
							{isCopied
								? getTranslation("Copied!", "Copied!", "Copied!")
								: getTranslation(
										"Copy generated code",
										"Copy generated code",
										"Copy generated code"
								  )}
						</Button>
					</Grid>
				);
			default:
				return null;
		}
	};

	return (
		<div className={styles.tabWrapper}>
			<CardComponent
				title={getTranslation("frame", "frame", "frame")}
				style={{ marginTop: "20px" }}
			>
				<Box display="flex" justifyContent="center">
					<StyledToggleButtonGroup value={codeToggle} color="success">
						<ToggleButton
							color="secondary"
							value="code"
							onClick={() => setcodeToggle("code")}
						>
							{getTranslation("Code", "Code", "Code")}
						</ToggleButton>

						<ToggleButton value="url" onClick={() => setcodeToggle("url")}>
							{getTranslation("URL", "URL", "URL")}
						</ToggleButton>
					</StyledToggleButtonGroup>
				</Box>
				<CardContent>{renderContent()}</CardContent>
			</CardComponent>
		</div>
	);
};
export default IframeTab;
